
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { MatchDay, Match, ScoreType } from '../store/models';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Actions as ScheduleActions} from '@/modules/schedule/store/actions';
import { Mutations as ScheduleMutations} from '@/modules/schedule/store/mutations';

import EditMatch from './EditMatch.vue';

import { scheduleModuleName } from '@/modules/schedule/store';
import MatchList from './MatchList.vue';
const scheduleModule = namespace(scheduleModuleName);

@Component({
  components: {
    FontAwesomeIcon,
    MatchList,
    EditMatch,
  },
})
export default class MatchDayListItem extends Vue {

  @Prop() public matchDay!: MatchDay;
  @Prop() public expanded!: boolean;

  private isBusy: boolean = true;
  private fetchedMatches: boolean = false;

  @scheduleModule.Action(ScheduleActions.FETCH_MATCH_DAY_MATCHES) private fetchMatchDayMatches!: (matchDayId: number) => void;
  @scheduleModule.Action(ScheduleActions.FETCH_DATA_FROM_LACZYNASPILKA) private fetchDataFromLaczyNasPilka!: (matchDayId: number) => void;
  @scheduleModule.Mutation(ScheduleMutations.SET_MATCH_DAY_ID_FOR_NEW_MATCH) private setMatchDayIdForNewMatch!: (matchDayId: number) => void;

  public mounted() {
    if (this.expanded) {
      this.displayContent();
    }
  }

  private addNewMatchClicked() {
    this.$emit('addNewMatchClicked', this.matchDay.id );
    setTimeout(this.showModal.bind(this), 200);
  }

  private async fetchDataClicked() {
    this.isBusy = true;
    await this.fetchDataFromLaczyNasPilka(this.matchDay.id as number);
    this.isBusy = false;
  }

  private editMatchClicked(matchId: number, matchDayId: number) {
    this.$emit('editMatchClicked', matchId, matchDayId );
  }

  private showModal() {
    (((this as any).$bvModal) as any).show(`editMatchModal`);
  }

  private hasAnyMatches() {
    return this.matchDay.matches !== undefined && this.matchDay.matches.length > 0;
  }

  private scoreIsProvided(match: Match) {
    return match.scoreType !== ScoreType.NoScore || (match.homeTeamScore && match.awayTeamScore);
  }

  private async displayContent() {
    if (!this.fetchedMatches) {
       await this.fetchMatchDayMatches(this.matchDay.id as number);
       this.fetchedMatches = true;
    }
    this.isBusy = false;
  }
}
